import { make } from "vuex-pathify";
import { getAPI, postAPI, getDownloadAPI } from "@/store/restAPI.js";//eslint-disable-line

// initial state
const state = {
    loading: false,
};

// getters
const getters = {};

// actions
const actions = {

    retrievePallets({ commit } , filter) {
        commit("SET_LOADING", true);
        return getAPI("pallet/retrievePallets" , filter).then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      retrievePalletswithOrders({ commit } , id) {
        commit("SET_LOADING", true);
        return getAPI("pallet/retrievePalletswithOrders", id).then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      retrievePalletswithOutOrders({ commit } , filter) {
        commit("SET_LOADING", true);
        return getAPI("pallet/retrievePalletswithOutOrders" , filter).then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },     

      retrieveWithOrdersAssociatedOrNot({ commit } , id) {
        commit("SET_LOADING", true);
        return getAPI("pallet/retrieveWithOrdersAssociatedOrNot" , id).then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      retrieveAllPallets({ commit }) {
        commit("SET_LOADING", true);
        return getAPI("pallet/retrievePallets").then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      retrievePalletItems({ commit }) {
        commit("SET_LOADING", true);
        return getAPI("pallet/retrievePalletItems").then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      retrievePalletsBySearch({ commit } , filter) {
        commit("SET_LOADING", true);
        return getAPI("pallet/retrievePalletsBySearch" , filter).then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      retrievePalletsForModal({ commit } , filter) {
        commit("SET_LOADING", true);
        return getAPI("pallet/retrievePalletsForModal" , filter).then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      erasePallet({ commit }, id) {
        commit("SET_LOADING", true);
        return postAPI("pallet/erasePallet/" + id).then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      disassemblePreview({ commit }, id) {
        commit("SET_LOADING", true);
        return getAPI("pallet/disassemblePreview/" + id).then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      disassemblePallet({ commit }, payload) {
        commit("SET_LOADING", true);
        var id = payload.id || payload;
        var body = {};
        if (payload.siloOverrides && payload.siloOverrides.length > 0) {
          body.siloOverrides = payload.siloOverrides;
        }
        if (payload.fieldAssignments && payload.fieldAssignments.length > 0) {
          body.fieldAssignments = payload.fieldAssignments;
        }
        return postAPI("pallet/disassemble/" + id, body).then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      exportExcelPallet({ commit } , filter) {
        commit("SET_LOADING", true);
        return getDownloadAPI("pallet/exportExcelPallet" , filter).then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      exportExcelConsolidated({ commit } , filter) {
        commit("SET_LOADING", true);
        return getDownloadAPI("pallet/exportExcelPallet" , filter).then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      savePallet({ commit } , pallet) {
        commit("SET_LOADING", true);
        return postAPI("pallet/savePallet" , pallet).then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      sendStock({ commit }, palletToSend) {
        commit("SET_LOADING", true);
        return postAPI("stockManager/sendStock", palletToSend).then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      retrievePalletsTrx({ commit } , id) {
        commit("SET_LOADING", true);
        return getAPI("pallet/retrievePalletsTrx", id).then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      retrievePalletsTrxBySearch({ commit } , filter) {
        commit("SET_LOADING", true);
        return getAPI("pallet/retrievePalletsTrxBySearch", filter).then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      countPallets({ commit } , filter) {
        commit("SET_LOADING", true);
        return getAPI("pallet/count", filter).then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      countPalletTrx({ commit } , filter) {
        commit("SET_LOADING", true);
        return getAPI("pallet/countTrx", filter).then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

};

// mutations
const mutations = {
    ...make.mutations(state),
  };
  
  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  };